import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_489_673)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M4.66162 1.16546V3.49638",
				stroke: "#717182",
				strokeWidth: 1.16546,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.32373 1.16546V3.49638",
				stroke: "#717182",
				strokeWidth: 1.16546,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.0717 2.33092H2.91351C2.26984 2.33092 1.74805 2.85271 1.74805 3.49638V11.6546C1.74805 12.2983 2.26984 12.8201 2.91351 12.8201H11.0717C11.7154 12.8201 12.2372 12.2983 12.2372 11.6546V3.49638C12.2372 2.85271 11.7154 2.33092 11.0717 2.33092Z",
				stroke: "#717182",
				strokeWidth: 1.16546,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.74805 5.8273H12.2372",
				stroke: "#717182",
				strokeWidth: 1.16546,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_489_673",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 13.9855,
			height: 13.9855,
			fill: "white"
		})
	}) })]
});
export default SvgCalendar;
